import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { PostDeclineReasons } from './post-decline-reasons.component'

@NgModule({
  imports: [CommonModule],
  declarations: [PostDeclineReasons],
  exports: [PostDeclineReasons]
})
export class PostDeclineReasonsModule {}
